import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { ensureListing } from '../../util/data';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes } from '../../util/types';

import css from './BookingBreakdown.module.css';


const LineItemBasePriceMaybe = props => {
  const { transaction, unitType, intl, listing } = props;
  const isNightly = unitType === LINE_ITEM_NIGHT;
  const isDaily = unitType === LINE_ITEM_DAY;
  const translationKey = isNightly
    ? 'BookingBreakdown.baseUnitNight'
    : isDaily
    ? 'BookingBreakdown.baseUnitDay'
    : 'BookingBreakdown.baseUnitQuantity';

  // Find correct line-item for given unitType prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/units', or 'line-item/time'
  // These are defined in '../../util/types';
  const unitPurchase = transaction.attributes.lineItems.find(
    item => item.code === unitType && !item.reversal
  );

  const seats= props.seats;

  
  //Checking if custom Currency is set to Euro
  const currentListing = ensureListing(listing);
  const currencyCheck = (customCurrency, shareTribePrice) => {
    if(customCurrency!==undefined){
      if ((customCurrency).includes('Euro')){
        return (shareTribePrice.substr(1)+ "€");
      }else{
        return shareTribePrice;
      }
    }else{
      return shareTribePrice;
    }
  }
  const quantity = unitPurchase ? unitPurchase.quantity.toString() : null;
  let unitPrice;
  if (unitPurchase){
    const formattedPrice = formatMoney(intl, unitPurchase.unitPrice);
    unitPrice = currencyCheck(currentListing.attributes.publicData.customCurrency, formattedPrice);
  }else{
    unitPrice = null;
  }
  
 
  let total;
  if (unitPurchase){
    const formattedPrice = formatMoney(intl, (unitPurchase.lineTotal));
    total = currencyCheck(currentListing.attributes.publicData.customCurrency, formattedPrice);
  }else{
    total = null;
  }

  return quantity && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} values={{ unitPrice, quantity }} />
      </span>
      <span className={css.itemValue}>{total}</span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  listing: propTypes.listing.isRequired,
  transaction: propTypes.transaction.isRequired,
  unitType: propTypes.bookingUnitType.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemBasePriceMaybe;
